import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Chart } from 'devextreme-react';
import moment from 'moment';
import { HistoricalResultsApis } from 'hooks/apis/HistoricalResultsApis';
import { IChartClientSpend } from 'interfaces/HistoricalResults/Dashboards/IChartClientSpend';

const JobsPerClientChart = () => {
  const [chartData, setChartData] = useState<IChartClientSpend[]>(null);
  const [error, setError] = useState<string>(null);
  const { getClientJobsDashboard } = HistoricalResultsApis();

  useEffect(() => {
    getClientJobsDashboard().then((data) => {
      if(data && !data.errorMessage){
        setChartData(data);
      }
      else if(data?.errorMessage){
        setError(data.errorMessage);
      }
    })
  }, [getClientJobsDashboard])

  const customizeTooltip = useCallback((pointInfo) => {
    return {
      html: `<div>
        <p style='font-size:14px; font-weight:bold; padding-bottom: 0; margin-bottom: 0;'>${pointInfo?.point?.series?.name}</p>
        <p style='font-size:14px; font-weight:bold;'>${pointInfo?.argument ? moment(pointInfo?.argument).format("MM/yyyy") : null }</p>
        <p style='font-size:12px;'><span>Number of Jobs:</span> ${pointInfo?.value}</p>
      </div>`
    };
  }, []);

  const formatAsDate = useCallback((argumentField) => {
    return argumentField?.value ? moment(argumentField?.value).format("MMM yyyy") : "";
  }, []);

  return (
    <Box className="dashboardChart">
      {error && chartData?.length === 0 ? <Box>{error}</Box> : null}

      {chartData && chartData?.length > 0 ?  <Chart
        title="Total jobs per month"
        dataSource={chartData}
        palette="Material"
        commonSeriesSettings={{argumentField: "Date", valueField: "NumberOfJobs", type: "line"}}
        seriesTemplate={{nameField: "Client"}}
        argumentAxis={{type: "discrete", label: {customizeText: formatAsDate, overlappingBehavior: "stagger"}}}
        valueAxis={{name: "Number of Jobs", position: "left", showZero: true, minValueMargin: 0, title:{text:"Number of jobs"}, valueMarginsEnabled: false, grid: {visible:true} }}
        legend={{horizontalAlignment: "center", verticalAlignment: "bottom"}}
        tooltip={{enabled: true, shared: true, customizeTooltip}}
       /> : null}
    </Box>
  );
};

export default JobsPerClientChart;
